<template>
  <div v-if="congress && league" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>
          Members of Congress
          <div class="h5">League: {{ league.name }}</div>
        </h2>
        <p>
          Search by name, chamber, and party. Click on a legislator's name to
          see more.<br />
          <span class="text-success" style="font-size:1.5rem">&#10003;</span> =
          Member currently belongs to a team.
        </p>
        <div class="fc-a-search">
          <input
            class="form-control fc-a-search__input"
            type="text"
            placeholder="Search Members of Congress..."
            v-model="congressSearch"
          />
          <button
            @click="search"
            type="button"
            name="button"
            class="btn btn-primary"
          >
            Search
          </button>
        </div>

        <!-- start table layout -->
        <table class="table fc-m-cong">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th class="d-none d-sm-table-cell" scope="col">Chamber</th>
              <th class=" d-none d-sm-table-cell" scope="col">
                State
              </th>
              <th class=" d-none d-lg-table-cell" scope="col">
                District
              </th>
              <th class=" d-none d-lg-table-cell" scope="col">
                Party
              </th>
              <th class=" " scope="col">
                Weekly Average
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="congress.length">
            <tr v-for="member in congress" v-bind:key="member.id">
              <td class="p-0">
                <div class="d-flex align-items-center">
                  <div
                    class="fc-m-cong__image"
                    :style="{
                      backgroundImage: `url(https://fc-congress-members.s3.us-east-2.amazonaws.com/${
                        member.bioguide
                      }.jpeg), url(https://fc-congress-members.s3.us-east-2.amazonaws.com/placeholder_square.jpeg)`
                    }"
                  ></div>
                  <router-link
                    :to="{ name: ':member', params: { memberId: member.id } }"
                    class="fc-m-cong__name"
                  >
                    <strong>
                      {{
                        member.common_name != ""
                          ? member.common_name
                          : member.first_name
                      }}
                      {{ member.last_name }}
                    </strong>
                  </router-link>
                </div>
              </td>
              <td class="d-none d-sm-table-cell">{{ member.chamber }}</td>
              <td class=" d-none d-sm-table-cell">
                {{ member.state }}
              </td>
              <td class=" d-none d-lg-table-cell">
                <span v-if="member.district != 0">
                  {{ member.district }}
                </span>
              </td>
              <td class=" d-none d-lg-table-cell">
                <svg
                  :title="member.party"
                  class="fc-a-icon fc-a-icon--size-6"
                  :class="'fc-a-icon--' + member.party.toLowerCase()"
                >
                  <use v-bind:xlink:href="'#icon_' + member.party" />
                </svg>
              </td>

              <td class=" ">
                <strong class="text-secondary">
                  {{ member.running_average }} pts
                </strong>
              </td>
              <td>
                <span
                  title="This legislator is taken."
                  class="text-success"
                  style="font-size:1.5rem"
                  v-if="isTaken(member.id)"
                  >&#10003;</span
                >
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="">
                No members found matching search criteria.
              </td>
            </tr>
          </tbody>
        </table>
        <!-- end table layout -->
        <div>
          <pagination
            v-if="previous || next"
            v-bind:next="next"
            v-bind:previous="previous"
            @newPage="getMembers"
          ></pagination>
        </div>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import Pagination from "@/views/components/Pagination";
import Loader from "@/views/components/Loader";

export default {
  name: "CongressAll",
  components: {
    pagination: Pagination,
    loader: Loader
  },
  data: function() {
    return {
      congress: null,
      league: null,
      next: null,
      previous: null,
      congressSearch: "",
      takenMembers: []
    };
  },
  created: function() {
    let app = this;
    this.getLeague().then(function(response) {
      app.$store.commit("breadcrumb/updateDynamicLinks", {
        dynamic_links: [
          {
            static_name: ":league",
            dynamic_name: response.name,
            url: `/leagues/${response.id}`
          }
        ]
      });
      app.$store.commit("breadcrumb/setCurrentPage", { name: "Congress" });
      app.league = response;
      // get taken members
      if (response.teams.length > 0) {
        for (let i = 0; i < response.teams.length; i++) {
          app.takenMembers = app.takenMembers.concat(
            response.teams[i].congress
          );
        }
      }

      let url =
        process.env.VUE_APP_CONGRESS +
        "/api/members/?limit=10&offset=0&status=active";
      app.getMembers(url);
    });
  },
  methods: {
    getLeague: function() {
      let app = this;
      return fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }`,
        {
          credentials: "include",
          mode: "cors"
        }
      ).then(function(response) {
        return response.json();
      });
    },
    getMembers: function(url) {
      let app = this;
      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          app.next = json.next;
          app.previous = json.previous;
          app.congress = json.results;
          app.$store.commit("breadcrumb/display");
        });
    },
    search: function() {
      let app = this;

      let url =
        process.env.VUE_APP_CONGRESS +
        "/api/members/?limit=10&offset=0&status=active&search=" +
        encodeURI(app.congressSearch);
      this.getMembers(url);
    },
    isTaken: function(memberId) {
      return this.takenMembers.includes(memberId);
    }
  }
};
</script>

<style lang="scss"></style>
